import React from 'react';
import { TouchableHighlight } from 'react-native';
import PropTypes from 'prop-types';
import Stats from 'modules/stats/mobile/stats.component';
import AvatarBox from 'modules/user/avatarbox.component';
import { useDispatch } from 'react-redux';
import { goToProfile } from 'modules/navigation/navigation.actions';
import { View, Text } from 'modules/styled';

DiscoverUser.propTypes = {
  type: PropTypes.string,
  user: PropTypes.object,
  actions: PropTypes.object,
  topic: PropTypes.string,
  renderRight: PropTypes.func,
  showRelevance: PropTypes.bool,
};

function DiscoverUser({ user, type, showRelevance, renderRight, topic }) {
  if (!user) return null;
  const dispatch = useDispatch();

  const setSelected = () => {
    if (type === 'invite') return;
    if (!user._id) return;
    dispatch(goToProfile(user));
  };

  const stats = (
    <Stats
      type={'percent'}
      topic={topic}
      entity={user}
      renderLeft={topic ? <Text /> : null}
    />
  );
  const right = renderRight ? renderRight() : stats;

  return (
    <TouchableHighlight underlayColor={'transparent'} onPress={() => setSelected()}>
      <View
        sx={{
          flex: 1,
          paddingY: 3,
          paddingX: [2, 0],
          variant: 'borders.navBorder',
          borderBottomWidth: 1,
        }}
      >
        <AvatarBox
          big
          inline={1}
          type={type}
          user={{ ...user }}
          setSelected={setSelected}
          showRelevance={showRelevance}
        />
        <View
          style={{
            alignItems: 'flex-end',
            justifyContent: 'center',
          }}
        >
          {right}
        </View>
      </View>
    </TouchableHighlight>
  );
}

export default DiscoverUser;
